import React from 'react';
import { PlaceOrder } from '../../components/PlaceOrder';

export const Home = () => {
    return (
        <PlaceOrder/>
    );
};
